import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ReportBuilder from "./pages/ReportBuilder";
import NewlyLaunchedProducts from "./pages/NewlyLaunchedProducts";
import MostSearched from "./pages/MostSearched";
import Account from "./pages/Account";
import PageTitleUpdater from "./components/PageTitleUpdater";
import { ReachOut } from "./pages/ReachOut";
import { useWindowSize } from "./hooks/useWindowSize";
import { TermsOfUse } from "./pages/TermsOfUse";
import { PrivacyPolicy } from "./pages/PrivacyPolicy";
import { useData } from "./context/DataProvider";
import Trends from "./pages/Trends";
import Trend from "./pages/Trend";
import Saved from "./pages/Saved";

function App() {
  
  const { width } = useWindowSize();
  const {isAuthenticated} = useData();
     const isMobile = width < 1024;
  return (
 <>
    
    {isMobile ? <p>This website is not optimized for mobile devices.</p>:
    <>
    <PageTitleUpdater/>
      <Routes>
        <Route path="/login" element={<Login />} />
        
        
        <Route path="/" element={isAuthenticated ? <Layout /> : <Navigate to="/login" replace />} >
          <Route index element={<Dashboard />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="report-builder" element={<ReportBuilder />} />
          <Route path="new-products" element={<NewlyLaunchedProducts />} />
          <Route path="most-searched" element={<MostSearched />} />
          <Route path="account" element={<Account />} />
          <Route path="terms-of-use" element={<TermsOfUse />} />
          <Route path="reach-out" element={<ReachOut />} />
          <Route path="trends" element={<Trends />} />
          <Route path="trend" element={<Trend />} />
          <Route path="saved" element={<Saved />} />
        </Route>
      </Routes>
      </>
  }
  </>
  );
}

export default App;
